<script>
import forminput from "../../FormComponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrStratejikAmac from "@/models/StrStratejikAmac"; 
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  mixins: [Api, Sabit, StrStratejikAmac],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
    Treeselect

  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    Get(){
      
    },
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

         if (
          this.FormData.Approval == "true" ||
          this.FormData.Approval == true
        ) {
          this.FormData.Approval = true;
        } else {
          this.FormData.Approval = false;
        }
        if (this.FormData.Hedefmi == "true" || this.FormData.Hedefmi == true) {
          this.FormData.Hedefmi = true;
        } else {
          this.FormData.Hedefmi = false;
        }

        if (!this.FormData.UstId || this.FormData.UstId == "0") {
          this.$delete(this.FormData, "UstId");
        }

        if (this.AddEdit == "Add") { 
 
              this.Post("StrStratejikAmac", this.FormData).then((res) => {
              if (res) {
                  this.$emit("TableUpdate");
                  this.$bvModal.hide("StrStratejikAmac");
              }

              });
        } else {
         
         this.Update("StrStratejikAmac", this.FormData).then((res) => {
              if (res) {
               
                this.$emit("TableUpdate");
                this.$bvModal.hide("StrStratejikAmac");
              }
         });

        }
      }
    },
  },
};
</script>
<template>


  <Loader>

  
    <b-modal
      id="StrStratejikAmac"
      size="lg"
      :title="this.AddEdit == 'Edit' ? $t('StrStratejikAmac.AddEdit.FormTitleEdit')
          : $t('StrStratejikAmac.AddEdit.FormTitleAdd')"
      title-class="font-18"
      hide-footer
    >


  <Form  @submit.prevent="onSubmit" > 
                       <div class="row">
                         <div class="col-md-12">
                            
                        
                        <div class="row">
                            <div class="col-md-12">
                            
                                 <forminput
                                  :title_position="'d-block'"
                                  :labels_lg="4"
                                  :FormDataType="FormDataType.Aciklama"
                                  :Value="FormData.Aciklama"
                                  :v="$v.FormData.Aciklama"
                                  @input="FormData.Aciklama = $event"
                                />   

                            </div>
                        </div>

                      <!-- <div class="row">
                            <div class="col-md-12">

                              <formcombobox
                                  :title_position="'d-block'"
                                  :labels_lg="4"
                                  :FormDataType="FormDataType.Donemid"
                                  :Value="FormData.Donemid"
                                  :v="$v.FormData.Donemid"
                                  @input="FormData.Donemid = $event"
                                />

                            </div>
                        </div>--> 

                        <div class="row">
                            <div class="col-md-12">

                        <b-form-group class="mb-3" id="example text"  label="Bağlı Olduğu Dönemler" label-for="text">
        
                              <treeselect 
                  
                              name="'donemler'"
                              id="'donemler'"
                              :options="FormDataType.Donemid.ComboDataArray"
                              :multiple="true"   
                              searchPromptText="Aramak için yazın..."
                              placeholder="Seçiniz..." 
                              v-model="FormData.Donemid"          
                              />
                              <treeselect-value :value="FormData.Donemid" />
                          </b-form-group>
                            </div>
                            </div>

                        
                         </div>
                            </div>

                    
                            <hr>
                       
                            <button class="btn btn-primary"  type="submit" >{{ $t("StrStratejikAmac.AddEdit.Button") }}</button> 

                          </Form>                       
                       


    </b-modal>
  </Loader>
</template>
